import React from "react";
import { Star, CheckCircle, Circle, Warning, XCircle } from "@phosphor-icons/react";

/**
 * Phase 3 — Prospect Quality Score badge.
 *
 * Renders a compact colored pill showing the tier of a business
 * (Excellent / Bon / Moyen / Faible / Exclure) plus its numeric score
 * on hover / tooltip. Silent when there's no score yet.
 */
const TIER_STYLE = {
  Excellent: { cls: "bg-primary/15 text-primary border-primary/40", Icon: Star },
  Bon:       { cls: "bg-emerald-500/15 text-emerald-700 border-emerald-500/40", Icon: CheckCircle },
  Moyen:     { cls: "bg-amber-500/15 text-amber-700 border-amber-500/40", Icon: Circle },
  Faible:    { cls: "bg-orange-500/15 text-orange-700 border-orange-500/40", Icon: Warning },
  Exclure:   { cls: "bg-secondary/15 text-secondary border-secondary/40", Icon: XCircle },
};

export default function QualityTierBadge({ tier, score, testid }) {
  if (!tier) return null;
  const style = TIER_STYLE[tier] || TIER_STYLE.Moyen;
  const { Icon } = style;
  const title = typeof score === "number"
    ? `Score qualité : ${score}/100 · Niveau ${tier}`
    : `Niveau qualité ${tier}`;
  return (
    <span
      className={`inline-flex items-center gap-1 border rounded-sm px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${style.cls}`}
      title={title}
      data-testid={testid}
    >
      <Icon size={10} weight="fill"/>
      {tier}
      {typeof score === "number" && (
        <span className="tabular-nums font-mono opacity-70 ml-0.5">{score}</span>
      )}
    </span>
  );
}
